import { useEffect, useState } from "react";
import { Button, Stack } from "@mui/material";
import PoLineItemsSection from "../PoLineItemsSection/PoLineItemsSection";
import { poPrimaryBtnSx, poSecondaryBtnSx } from "../poUi";

/**
 * Selected-PO item details: view by default; Edit toggles inline edit (Upload/Add + Save).
 * No nested edit modal.
 */
const DisplayPoItemDetails = ({ items = [], onSave, disableEdit = false, saving = false }) => {
	const [editing, setEditing] = useState(false);
	const [draft, setDraft] = useState(items || []);
	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		if (!editing) setDraft(items || []);
	}, [items, editing]);

	const handleCancel = () => {
		if (submitting || saving) return;
		setDraft(items || []);
		setEditing(false);
	};

	const handleSave = async () => {
		if (submitting || saving) return;
		setSubmitting(true);
		try {
			if (typeof onSave === "function") {
				await onSave(draft);
			}
			setEditing(false);
		} finally {
			setSubmitting(false);
		}
	};

	const busy = submitting || saving;

	if (!editing) {
		return (
			<PoLineItemsSection
				items={items}
				readOnly
				toolbarActions={
					!disableEdit ? (
						<Button variant="contained" size="small" onClick={() => setEditing(true)} sx={poPrimaryBtnSx}>
							Edit
						</Button>
					) : null
				}
			/>
		);
	}

	return (
		<PoLineItemsSection
			items={draft}
			onChange={setDraft}
			toolbarActions={null}
			extraToolbarActions={
				<Stack direction="row" spacing={0.75} alignItems="center" flexShrink={0}>
					<Button variant="outlined" size="small" onClick={handleCancel} disabled={busy} sx={poSecondaryBtnSx}>
						Cancel
					</Button>
					<Button variant="contained" size="small" onClick={handleSave} disabled={busy} sx={poPrimaryBtnSx}>
						{busy ? "Saving…" : "Save"}
					</Button>
				</Stack>
			}
		/>
	);
};

export default DisplayPoItemDetails;
